import registerImage from '../../../common/images/index';
import presentationalComponent from './Image';
import containerComponent from './ImageContainer';
import modalComponent from './modal/ImageModal';

import { isApple } from '../../utils/services/browser';

import { TOOLS } from '../../workspace/toolbar/toolbarConstants';

export default () =>
    registerImage({
        presentationalComponent,
        containerComponent,
        modalComponent,
        tools: [
            TOOLS.RICH_TEXT,
            TOOLS.COLOR,
            TOOLS.CAPTION,
            TOOLS.SHOW_BACKGROUND,
            TOOLS.IMAGE_EDIT,
            TOOLS.EDIT_DRAWING,
            TOOLS.REACTION,
        ],
        tooltip: isApple ? '⌃⌘I' : 'Ctrl+Alt+I',
    });
